import ContactRSVPStatus from './ContactRSVPStatus';

export default ContactRSVPStatus;
